import { useGameStore } from '@/store/gameStore'
import { TOURNAMENT_DEFINITIONS, getBracketChampion } from '@/config/tournamentConfig'
import { acceptTournamentOffer, declineTournamentOffer } from '@/game/systems/TournamentSystem'
import { BracketView } from '../components/BracketView'
import { SectionDeck, EmptyStateRich } from '../components/CourtVision'
import { BroadcastHeader, AngledButton } from '../components/broadcast'
import { Trophy, Inbox } from 'lucide-react'
import { GameIcon } from '../icons/iconMap'

export function TournamentsTabContent() {
  const { day, players, activeTournament, tournamentOffers, setActiveTournament } = useGameStore()

  const canEnterPair = players.length >= 2
  const showOffers = !activeTournament || activeTournament.status === 'completed'
  const champion = activeTournament?.bracket ? getBracketChampion(activeTournament.bracket) : null

  return (
    <div>
      {activeTournament && (
        <>
          <BroadcastHeader
            title={activeTournament.name}
            competition="Torneo"
            trophySrc="/assets/broadcast/trophy-tournament.webp"
            meta={
              <>
                <span>
                  {activeTournament.status === 'upcoming' && `Comienza día ${activeTournament.startDay}`}
                  {activeTournament.status === 'in_progress' &&
                    `En progreso · Día ${day - activeTournament.startDay + 1}/${activeTournament.duration}`}
                  {activeTournament.status === 'completed' && champion && (
                    <span style={{ color: champion.isClubTeam ? 'var(--gold)' : undefined }}>
                      <Trophy size={12} style={{ display: 'inline', verticalAlign: '-2px' }} /> Campeones:{' '}
                      {champion.name}
                      {champion.isClubTeam && ' — ¡Tu pareja!'}
                    </span>
                  )}
                </span>
                <span className="chip-angled">{activeTournament.participants} parejas</span>
                <span className="chip-angled tone-gold">€{activeTournament.prizePool.toLocaleString()}</span>
                {activeTournament.clubPairIds && (
                  <span className="chip-angled tone-accent">Pareja del club inscrita</span>
                )}
              </>
            }
            action={
              activeTournament.status === 'completed' ? (
                <AngledButton tone="neutral" onClick={() => setActiveTournament(null)}>
                  Cerrar
                </AngledButton>
              ) : undefined
            }
          />

          {activeTournament.bracket && (
            <div className="panel tx-net" style={{ marginBottom: '1.5rem', position: 'relative' }}>
              <BracketView bracket={activeTournament.bracket} />
            </div>
          )}
        </>
      )}

      {tournamentOffers.length > 0 && showOffers && (
        <SectionDeck title="Ofertas de torneo" icon={Inbox} meta={`${tournamentOffers.length} disponible${tournamentOffers.length === 1 ? '' : 's'}`}>
          <div className="space-y-2">
            {tournamentOffers.map(type => {
              const def = TOURNAMENT_DEFINITIONS[type]
              return (
                <div key={type} className="action-item tx-perforations" style={{ cursor: 'default' }}>
                  <span className="action-icon"><GameIcon domain="tournament" id={type} size={18} /></span>
                  <div className="action-info">
                    <div className="action-name">{def.name}</div>
                    <div className="meta-text">{def.description}</div>
                    <div style={{ fontSize: '0.7rem' }}>
                      <span style={{ color: 'var(--gold)' }}>+{def.reputationBonus} rep </span>
                      <span className="money-positive">~&euro;{(def.entryFeeRange[1] * def.participantsRange[1] * 0.2).toLocaleString()}</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', alignItems: 'stretch' }}>
                    <AngledButton tone="gold" onClick={() => acceptTournamentOffer(type, false)}>
                      Organizar
                    </AngledButton>
                    {canEnterPair && (
                      <AngledButton
                        tone="accent"
                        onClick={() => acceptTournamentOffer(type, true)}
                        title="Tus 2 mejores jugadores entran en el cuadro"
                      >
                        Con pareja
                      </AngledButton>
                    )}
                    <AngledButton tone="neutral" onClick={() => declineTournamentOffer(type)}>
                      Rechazar
                    </AngledButton>
                  </div>
                </div>
              )
            })}
          </div>
        </SectionDeck>
      )}

      {!activeTournament && tournamentOffers.length === 0 && (
        <EmptyStateRich
          icon={Trophy}
          title="Sin torneos a la vista"
          sub="Construye más pistas y gana reputación para que lleguen ofertas al club"
        />
      )}
    </div>
  )
}
